/* Core & libraries */
import React from "react";
import { useTheme } from "react-jss";

/* Components */
import PromotionsPageHeader from "../../components/promotionsPageHeader";
import PromotionsTabbedNav from "../../components/promotionsTabbedNav";

/* Styles */
import styles from "./styles";

const Promotions = () => {
  const theme = useTheme();
  const classes = styles({ theme });

  return (
    <div className={classes.promotionsPage}>
      <PromotionsPageHeader />
      <PromotionsTabbedNav />
    </div>
  );
};

export default Promotions;
